import FreelancerList from './FreelancerList';

export default FreelancerList;


